<template>
  <v-tab-item :value="$route.fullPath" class="pa-3">
    <v-toolbar flat height="90">
      <ExportLinks export-key="store-coupons" />

      <v-spacer></v-spacer>

      <v-col cols="12" sm="4">
        <b-search-field v-model="search"></b-search-field>
      </v-col>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="coupons"
      :footer-props="{
        itemsPerPageOptions: [12],
        showCurrentPage: true,
        pageText: `${page * 12 - 11}-${
          page * 12 <= serverItemsLength ? page * 12 : serverItemsLength
        } ${translations.paginationText[lang]} ${serverItemsLength}`,
      }"
      :page.sync="page"
      :loading="loading"
      :server-items-length="serverItemsLength"
      class="b-outlined"
    >
      <template v-slot:item.gift_image="{ item }">
        <v-img :src="item.gift_image" width="70" v-if="item.gift_image"></v-img>
        <div v-else>-</div>
      </template>

      <template v-slot:item.edit="{ item }">
        <v-tooltip color="secondary" top>
          <template v-slot:activator="{ on }">
            <v-btn color="yellow darken-3" icon v-on="on" @click="myFunc(item)">
              <v-icon v-text="icons.mdiPencilOutline"></v-icon>
            </v-btn>
          </template>

          <span class="font-weight-bold">Update</span>
        </v-tooltip>
      </template>

      <template v-slot:item.view="{ item }">
        <v-tooltip color="secondary" top>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              v-on="on"
              @click="
                () => {
                  coupon_id = item.coupon_id;
                  additionalDialog = true;
                }
              "
            >
              <v-icon v-text="icons.mdiEye"></v-icon>
            </v-btn>
          </template>

          <span class="font-weight-bold" v-text="translations.modalTitle[lang]"></span>
        </v-tooltip>
      </template>
    </v-data-table>

    <v-dialog v-model="additionalDialog" max-width="800">
      <AdditionalInfo :couponId="coupon_id" @cancel="additionalDialog = false" />
    </v-dialog>
  </v-tab-item>
</template>

<script>
import couponsOverview from '@/store/modules/storePanel/redeem/couponsOverview';

import { mdiPencilOutline, mdiEye } from '@mdi/js';

import { mapState, mapMutations, mapActions } from 'vuex';
import translations from '@/utils/translations/storePanel/couponsOverview';
import ExportLinks from '@/components/general/ExportLinks.vue';
import AdditionalInfo from '@/components/storePanel/redeem/couponsOverview/AdditionalInfo.vue';
import debounce from 'lodash/debounce';

export default {
  name: 'CouponsOverview',

  components: { ExportLinks, AdditionalInfo },

  mixins: [translations],

  data() {
    return {
      icons: { mdiPencilOutline, mdiEye },
      page: +this.$route.query.page,
      search: '',
      coupon_id: null,
      additionalDialog: false,
    };
  },

  computed: {
    ...mapState(['loading', 'serverItemsLength', 'superUser']),
    ...mapState('storePanel/couponsOverview', ['coupons']),

    lang() {
      return this.$route.params.lang;
    },

    permission() {
      return this.$store.state.permissions.redemption
        ? this.$store.state.permissions.redemption.coupons_overview
        : this.superUser;
    },
    storeMode() {
      return this.$store.state.store?.display_mode || 'points';
    },
    headers() {
      return [
        {
          text: this.translations.image[this.lang],
          value: 'gift_image',
        },
        {
          text: this.translations.promoType[this.lang],
          value: 'promo_type_name',
        },
        {
          text: this.translations.promoName[this.lang],
          value: 'gift_title',
        },
        {
          text: this.translations.available[this.lang],
          value: 'available',
        },
        { text: this.translations[this.storeMode][this.lang], value: 'points' },
        {
          text: this.translations.totalRedeemed[this.lang],
          value: 'total_redeemed',
        },
        {
          text: this.translations.view[this.lang],
          value: 'view',
        },
      ];
    },

    query() {
      let query = '?';

      for (let key in this.$route.query) {
        query += `${key}=${this.$route.query[key]}&`;
      }

      return query.slice(0, query.length - 1);
    },
  },

  methods: {
    ...mapActions('storePanel/couponsOverview', ['getItems']),

    handleSearch() {
      this.getItems(`?q=${this.search}`);
    },
  },

  created() {
    this.debouncedSearch = debounce(this.handleSearch, 500);
  },

  watch: {
    permission: {
      immediate: true,
      handler(val) {
        if (!val && !this.superUser) {
          this.$router.replace(`/${this.lang}/storePanel/forbidden-gateway`);
        }
      },
    },

    search(val, oldVal) {
      if (val == null) {
        this.getItems(this.query);
      } else {
        this.debouncedSearch();
      }
    },

    $route(val) {
      if (!val.query.page) {
        this.$router.replace({
          query: {
            page: 1,
            ...this.$route.query,
          },
        });
      }
      this.getItems(this.query);
    },

    page(page) {
      this.$router.replace({ query: { ...this.$route.query, page } });
    },
  },

  beforeCreate() {
    if (!this.$store.state.storePanel.couponsOverview) {
      this.$store.registerModule(['storePanel', 'couponsOverview'], couponsOverview);
    }

    if (!this.$route.query.page) {
      this.$router.replace({
        query: {
          page: 1,
          ...this.$route.query,
        },
      });
    }
  },

  mounted() {
    this.getItems(this.query);
  },
};
</script>
